import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import DocumentMeta from 'react-document-meta';
import prepareMetaData from 'util/prepareMetaData';
import DefaultHeader from './DefaultHeader';
import PodcastDetailPageHeader from './PodcastDetailPageHeader';
import { PageSchema } from '../Schema';

class PageHeader extends PureComponent {
  static defaultProps = {
    image: null,
    logo: null,
    isPodcastDetailPage: false,
    isDevicesPage: false,
    metadata: null,
    title: null,
    page: null,
    podcast: null,
    station: null,
    isStationPage: null,
    description: null,
    subtitle: null,
    pageLink: null,
    slug: null,
    contentTypeId: null,
  };

  static propTypes = {
    image: PropTypes.object,
    logo: PropTypes.object,
    isPodcastDetailPage: PropTypes.bool,
    metadata: PropTypes.object,
    title: PropTypes.string,
    page: PropTypes.object,
    podcast: PropTypes.object,
    station: PropTypes.object,
    isStationPage: PropTypes.bool,
    description: PropTypes.string,
    subtitle: PropTypes.string,
    pageLink: PropTypes.string,
    slug: PropTypes.string,
    contentTypeId: PropTypes.string,
  };

  renderHeader = () => {
    const { metadata, podcast, isPodcastDetailPage } = this.props;

    if (isPodcastDetailPage) {
      return (
        <Fragment>
          <DefaultHeader />
          <PodcastDetailPageHeader {...this.props} {...podcast} metadata={metadata} />
        </Fragment>
      );
    }

    return <DefaultHeader />;
  };

  render() {
    const { metadata, title, description, subtitle, page, pageLink, slug, image, logo, contentTypeId } = this.props;
    const canonicalUrl = window.location.origin.concat(window.location.pathname);
    const tags = (metadata || {}).tags;
    const pageType = (page || {}).pageType || contentTypeId;
    const type = pageType === 'station' && contentTypeId ? contentTypeId : pageType;

    return (
      <DocumentMeta {...prepareMetaData(metadata, title)} extend canonical={canonicalUrl}>
        <PageSchema
          type={type}
          name={title}
          id={pageLink || slug}
          image={image && image.url}
          logo={logo && logo.url}
          description={(metadata || {}).description || description || subtitle}
          keywords={tags && tags.join(',')}
        />
        {this.renderHeader()}
      </DocumentMeta>
    );
  }
}

export default PageHeader;
